import { render } from "./ListCommandesFournisseurs.vue?vue&type=template&id=15e5940c&ts=true"
import script from "./ListCommandesFournisseurs.vue?vue&type=script&lang=ts"
export * from "./ListCommandesFournisseurs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__